var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6485 2.95373H18.267V1.763C18.267 1.4472 18.1416 1.14433 17.9182 0.921023C17.6949 0.697717 17.3921 0.572266 17.0763 0.572266C16.7605 0.572266 16.4576 0.697717 16.2343 0.921023C16.011 1.14433 15.8855 1.4472 15.8855 1.763V2.95373H8.74114V1.763C8.74114 1.4472 8.61569 1.14433 8.39238 0.921023C8.16907 0.697717 7.86621 0.572266 7.5504 0.572266C7.2346 0.572266 6.93173 0.697717 6.70843 0.921023C6.48512 1.14433 6.35967 1.4472 6.35967 1.763V2.95373H3.97821C3.0308 2.95373 2.1222 3.33009 1.45228 4.00001C0.782362 4.66992 0.406006 5.57852 0.406006 6.52593V20.8147C0.406006 21.7621 0.782362 22.6707 1.45228 23.3407C2.1222 24.0106 3.0308 24.3869 3.97821 24.3869H20.6485C21.5959 24.3869 22.5045 24.0106 23.1744 23.3407C23.8443 22.6707 24.2207 21.7621 24.2207 20.8147V6.52593C24.2207 5.57852 23.8443 4.66992 23.1744 4.00001C22.5045 3.33009 21.5959 2.95373 20.6485 2.95373ZM21.8392 20.8147C21.8392 21.1305 21.7137 21.4334 21.4904 21.6567C21.2671 21.88 20.9643 22.0055 20.6485 22.0055H3.97821C3.6624 22.0055 3.35954 21.88 3.13623 21.6567C2.91292 21.4334 2.78747 21.1305 2.78747 20.8147V12.4796H21.8392V20.8147ZM21.8392 10.0981H2.78747V6.52593C2.78747 6.21013 2.91292 5.90726 3.13623 5.68396C3.35954 5.46065 3.6624 5.3352 3.97821 5.3352H6.35967V6.52593C6.35967 6.84173 6.48512 7.1446 6.70843 7.36791C6.93173 7.59121 7.2346 7.71666 7.5504 7.71666C7.86621 7.71666 8.16907 7.59121 8.39238 7.36791C8.61569 7.1446 8.74114 6.84173 8.74114 6.52593V5.3352H15.8855V6.52593C15.8855 6.84173 16.011 7.1446 16.2343 7.36791C16.4576 7.59121 16.7605 7.71666 17.0763 7.71666C17.3921 7.71666 17.6949 7.59121 17.9182 7.36791C18.1416 7.1446 18.267 6.84173 18.267 6.52593V5.3352H20.6485C20.9643 5.3352 21.2671 5.46065 21.4904 5.68396C21.7137 5.90726 21.8392 6.21013 21.8392 6.52593V10.0981Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.14795,
    y: 14.271,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25757,
    y: 14.271,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3672,
    y: 14.271,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4768,
    y: 14.271,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.14795,
    y: 18.0645,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25757,
    y: 18.0645,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3672,
    y: 18.0645,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4768,
    y: 18.0645,
    width: 2.00212,
    height: 2.10749,
    rx: 0.238147,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.1c0c86d3e82d56bd7af77004fd8bf53a.svg";
export { ForwardRef as ReactComponent };